module.exports = __webpack_public_path__ + "static/media/Ficha.b9045be8.pdf";